<style>
.van-tabs__wrap--scrollable .van-tab{font-weight: bold}
.van-tab{font-weight: bold}
</style>
<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="banner-box">
      <div class="banner-con">
        <div class="banner-title">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>低代码开发平台</div>
        <div class="banner-desc">让软件开发更简单</div>
        <div class="app-button-div">
          <img class="app-button-img" src="../assets/img/zeroCodePhone/app-button-bg.png" @click="handleOpenPractice"/>
        </div>
        <!--更敏捷的企业数字化转型支撑工具-->
        <div class="div-title">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>低代码开发平台</div>
        <div class="div-title" style="margin-top: -15px">是企业数字化转型的底座</div>
        <div class="div-desc" style="font-size: 13px">支持拖拉拽+快速配置的开发方式，仅需约20%手工开发代码量</div>
        <div style="text-align: center">
          <img src="../assets/img/lowCodePhone/div-base-img1.png" style="max-width: 90%;">
          <img src="../assets/img/lowCodePhone/div-base-img2.png" style="max-width: 90%;margin-top: 20px;margin-bottom: 40px">
        </div>
        <!--架构图-->
        <div class="div-big">
          <div class="div-title">架构图</div>
          <div class="digitalize">
            <div class="digitalize-bg">
              <img src="../assets/img/lowCodePhone/big-img.png" />
            </div>
          </div>
        </div>
        <!-- 平台具备很强的扩展性-->
        <div class="model">
          <div class="div-title">平台具备很强的扩展性</div>
          <van-tabs
            v-model="modelActive"
            animated
            swipeable
            duration="0.5"
            line-width="80px"
            line-height="2px"
            title-active-color="#186CF5"
            color="#186CF5"
            type="line"
          >
            <van-tab title="公式编辑" name="formular">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/phoneHomePage/model-1.gif" alt="" />
                <!-- <img :src="formular" /> -->
              </div>
            </van-tab>
            <van-tab title="前端代码块" name="frontCode">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/phoneHomePage/model-2.gif" alt="" />
                <!-- <img :src="frontCode" /> -->
              </div>
            </van-tab>
            <van-tab title="外部资源注册" name="external">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/phoneHomePage/model-3.gif" alt="" />
                <!-- <img :src="external"/> -->
              </div>
            </van-tab>
            <van-tab title="代码全解析" name="codeAnalysis">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/phoneHomePage/model-4.gif" alt="" />
                <!-- <img :src="codeAnalysis" /> -->
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <!-- 主要功能 -->
        <div class="main-method">
          <div class="div-title">主要功能</div>
          <van-tabs
            v-model="mainActive"
            animated
            swipeable
            duration="0.5"
            line-width="90px"
            line-height="2px"
            title-active-color="#186CF5"
            color="#186CF5"
            background="#F1F5FB"
            swipe-threshold="3"
          >
            <van-tab title="可视化设计器" name="first">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/function1.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>提供基于拖拽配置式的可视化页面、流程设计器</div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>
                      提供扩展组件库、自定义组件库、页面模板库、公共样式库等资源库
                    </div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>
                      支持复杂场景下的原型绘制、功能开发、数据库设计、流程设计、移动开发等工作
                    </div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>完美还原UI设计效果</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="基础服务平台" name="second">
              <div class="main-tabs-tabItem">
                <img :src="funcSrc" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>
                      包含组织权限中心、门户配置中心、开发者中心等子系统
                    </div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>
                      提供组织权限功能服务、系统管理服务、多租户管理服务、任务调度、系统监控、门户配置等功能服务
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="移动开发平台" name="third">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/function3.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>
                      支持移动应用可视化开发，快速实现移动业务数据与页面元件的数据绑定
                    </div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>支持多种移动开发方式，如原生、混合、H5等</div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>支持鸿蒙、安卓、iOS等移动操作系统</div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>一套APP代码，多平台通用</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="工作流平台" name="fourth">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/function4.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>流程模型符合BPMN2.0国际标准</div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>支持100余项流程接口、20余项中国式流程功能</div>
                  </div>
                  <div class="main-tabs-tabItem-context-item">
                    <img src="../assets/img/phoneHomePage/main-item.png" />
                    <div>支持流程与表单的可视化权限配置</div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <!-- 快速构建轻应用 -->
        <div class="div-title" style="position: relative;top: -20px">快速构建轻应用</div>
        <div class="core-value">
          <div class="core-layout">
            <div class="core-content">
              <div class="core-item">
                <div>
                  <span class="value-title">原型开发</span>
                  <div class="value-desc">轻骑兵 低代码平台可视化的设计和开发方式使得用户可快速构建出高保真的原型系统，帮助开发人员更快地了解项目需求，以便更好地设计和开发产品。</div>
                  <img src="../assets/img/lowCodePhone/core-item-1.png" />
                </div>
              </div>
              <div class="core-item" style="height: 175px">
                <div>
                  <span class="value-title">企业内部应用</span>
                  <div class="value-desc">轻骑兵 低代码平台提供了丰富的内置组件和模板库，帮助开发者快速构建出符合企业实际需求的应用。同时，平台具备强大的集成能力，可与客户现有系统进行集成。</div>
                  <img src="../assets/img/lowCodePhone/core-item-2.png" style="top: -110px"/>
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title">中大型项目</span>
                  <div class="value-desc">轻骑兵 低代码平台可减少手动编码、简化开发流程的优点使得轻骑兵低代码开发平台成为需快速开发和部署的中大型项目的理想选择。</div>
                  <img src="../assets/img/lowCodePhone/core-item-3.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 案例 -->
        <div class="case">
          <div class="case-title">案例</div>
          <div class="case-box">
            <van-swipe class="case-swipe" :width="300" :loop="false">
              <van-swipe-item>
                <div class="case-item">
                  <img
                    src="../assets/img/phoneHomePage/swipe-1.png"
                    style="width: 100%"
                  />
                  <div class="title">华中科技公司 余主任</div>
                  <div class="text">
                    轻骑兵低代码开发平台统一了公司的技术架构，完善了公司的研发体系，该平台的可视化设计器支持定制各种自定义组件，赋能公司设计团队，助力公司技术积累。
                  </div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="case-item">
                  <img src="../assets/img/phoneHomePage/swipe-2.png" />
                  <div class="title">航天科工集团某研究所 李总</div>
                  <div class="text">
                    轻骑兵的可视化设计器很好用，基于平台可以快速进行可视化开发，提升我们的研发效率，平台符合分保要求，支持多版本兼容，这对我们而言是非常重要的两点。
                  </div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="case-item">
                  <img src="../assets/img/phoneHomePage/swipe-3.png" />
                  <div class="title">联通河北分公司 赵经理</div>
                  <div class="text">
                    轻骑兵低代码开发平台，对业务场景具备快速实现能力，可视化开发模式降低了应用软件的开发难度，开发效率大幅提升。在客户项目中，平台能够快速友好的同其他系统进行整合，实现数据双向交换、共享业务处理流程，同时也减轻了软件维护的负担。
                  </div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="case-item">
                  <img src="../assets/img/phoneHomePage/swipe-4.png" />
                  <div class="title">玫德集团 生经理</div>
                  <div class="text">
                    轻骑兵低代码开发平台显著降低了企业开发人员数量和水平的要求，能够快速响应客户需求，灵活应用在复杂的开发场景中，降低开发人员的工作量，大幅提高编码效率。
                  </div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="case-item">
                  <img src="../assets/img/phoneHomePage/swipe-6.png" />
                  <div class="title">中泰证券 梁经理</div>
                  <div class="text">
                    轻骑兵低代码开发平台统一了后续公司平台的技术框架，各部门的开发成果以组件的形式得到了积累复用，提高了开发效率，极大的减少了不同系统中互联互通的成本，避免了资源的浪费。
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="case-application-box">
            <div class="case-application">
              <div class="title">应用行业</div>
              <van-divider :style="{ borderColor: '#FFFFFF' }" />
              <div class="case-application-items">
                <div class="case-application-item">
                  <div>电力能源</div>
                  <div>智能制造</div>
                  <div>工程建筑</div>
                </div>
                <div class="case-application-item">
                  <div>轨道交通</div>
                  <div>冶金冶炼</div>
                  <div>政务服务</div>
                </div>
                <div class="case-application-item">
                  <div>航天军工</div>
                  <div>证券金融</div>
                  <div>产教融合</div>
                </div>
                <div class="case-application-item">
                  <div>石油石化</div>
                  <div>移动通信</div>
                  <div>商业服务</div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn">
            <img src="../assets/img/phoneHomePage/liaojiegengduo-button.png" @click="handleOpenPractice" style="width: 130px">
          </div>
        </div>
        <!-- 底部公司信息 -->
        <CompanyInformation
          @changePracticeMenuShow="handleOpenPractice"
        ></CompanyInformation>
      </div>
      <!-- 右侧菜单 -->
      <RightMenu
        :isMenuShow="isMenuShow"
        @rightMenuShow="handleRightMenuShow"
      ></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow
        :isPopShow="isPopShow"
        @CloseExperienceNow="handleCloseExperienceNow"
      ></ExperienceNow>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import Swiper, { Navigation } from "swiper";
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import CompanyInformation from "./include/CompanyInformation";
import ExperienceNow from "./include/ExperienceNow";
const function21 = require("../assets/img/homePage/function21.gif");
const function22 = require("../assets/img/homePage/function22.gif");
Swiper.use([Navigation]);
export default {
  name: "ZeroCodePhone",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      videoPlayDialogVisible: false, // 顶部视频播放弹窗
      modelActive: "formular", // tab页默认显示
      mainActive: "first", // tab页默认显示
      funcSrc: "function21", // 动图播放完毕后显示gif
    };
  },
  watch: {
    mainActive(n) {
      if (n === "second") {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 3000);
      }
    },
  },
  methods: {
    // 了解更多
    handleRouter() {
      this.$router.push("/CasePhonePage");
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 头部 */
.banner-box {width: 100%;height: 391px;background: url("../assets/img/lowCodePhone/banner-bg.png") no-repeat;background-size: 100%;margin-top: 52px;}
.banner-con {width: 100%;margin: 0 auto;padding-top: 20px;}
.banner-title {font-size: 23px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;}
.banner-desc {display: flex;align-items: center;position: relative;font-size: 16px;font-weight: 400;justify-content: center;}
.app-button-div{width: 100%;text-align: center;margin-top: 190px}
.app-button-img{width: 120px;}

.div-title {font-size: 22px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;color: #2e2e2e;margin-top: 50px}
.div-desc {display: flex;align-items: center;position: relative;font-size: 14px;font-weight: 400;justify-content: center;color: #8E8E8E;margin-bottom: 30px}


/* 架构图 */
.div-big{background: url('../assets/img/lowCodePhone/big-img-bg.png') no-repeat;background-size: 100% 100%;padding-top: 1px}
.div-big .div-title{margin:30px 0px 20px 0px}
.digitalize {width: 100%;}
.digitalize > img {width: 100%;margin-top: 20px;}
.digitalize-bg {text-align: center;padding: 0 18px;}
.digitalize-bg > img {width: 100%;margin-bottom: 30px;}

/* 主要功能 */
.main-method {overflow: hidden;background: rgb(241, 245, 251);padding-bottom: 30px}
.main-tabs-tabItem {display: flex;margin: 10px 0 30px 0;justify-content: center;}
.main-tabs-tabItem > img {height: 200px;}
.main-tabs-tabItem-box {display: flex;justify-content: center;height: 100%;min-height: 100px;}
.main-tabs-tabItem-box > div {width: 90%;}
.main-tabs-tabItem-context-item {display: flex;margin-bottom: 10px;}
.main-tabs-tabItem-context-item > img {height: 20px;padding-right: 10px;}
.main-tabs-tabItem-context-item > div {font-size: 15px;line-height: 25px;}

/* 快速构建轻应用 */
.core-value {background: #FFFFFF;}
.core-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 40px 0 30px 0;}
.core-layout {display: flex;padding-bottom: 30px;}
.core-content {width: 90%;margin: auto;color: #FFFFFF;}
.value-title {font-size: 16px;font-weight: bold;}
.value-desc {font-size: 13px;margin-top: 15px;line-height: 25px;color: #EEEEEE;}
.core-item {text-align:justify;background: #3273F3;height: 150px;background-size: 100% 80px;margin-bottom: 20px;display: flex;padding: 20px 20px;border-radius: 3px;}
.core-item img{width: 100px;position: relative;left: 220px;top: -92px;}

/* 案例 */
.case {background: url("../assets/img/phoneHomePage/case-bg.png");height: 828px;}
.case-title {font-size: 25px;font-weight: bold;line-height: 56px;text-align: center;padding: 30px 0;color: white;}
.case-box {display: flex;justify-content: center;}
.case-swipe {height: 350px;}
.case-swipe >>> .van-swipe__indicators .van-swipe__indicator {background: #333333;}
.case-swipe >>> .van-swipe__indicator--active {background-color: #1989fa !important;}
.case-item {height: 100%;width: 90%;padding: 20px 20px 0 20px;background-image: linear-gradient(to bottom, #fff, #e9f0ff);border-radius: 5px;}
.van-swipe-item {display: flex;justify-content: center;}
.case-item > img {height: 55px;}
.case-item > .title {margin: 10px 0;font-size: 18px;font-weight: 600;}
.case-item > .text {font-size: 15px;font-weight: 400;line-height: 25px;}
.case-application-box {display: flex;justify-content: center;}
.case-application {width: 90%;height: 200px;padding: 20px;background: #203558;margin-top: 40px;}
.case-application .title {color: #fff;font-size: 18px;font-weight: bold;}
.case-application-items {display: flex;justify-content: space-between;}
.case-application-item > div {font-size: 15px;color: #fff;margin-bottom: 15px;}
.case > .btn {display: flex;justify-content: center;margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/LowCodePhone.vue